var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrophone = function SvgIconMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.65a3.5 3.5 0 0 0-3.5 3.5v7a3.5 3.5 0 0 0 7 0v-7a3.5 3.5 0 0 0-3.5-3.5m0 13h-.065a2.5 2.5 0 0 1-2.435-2.5v-7a2.5 2.5 0 0 1 5 0v7a2.5 2.5 0 0 1-2.5 2.5m-4.5-4.625a.5.5 0 1 0-1 0v2.125a5.5 5.5 0 0 0 5 5.478v3.022H8a.5.5 0 1 0 0 1h8a.5.5 0 0 0 0-1h-3.5v-3.022a5.5 5.5 0 0 0 5-5.478v-2.125a.5.5 0 1 0-1 0v2.125a4.5 4.5 0 0 1-.27 1.538l-.006.017a4.5 4.5 0 0 1-1.963 2.337l-.012.007A4.5 4.5 0 0 1 12 17.65a4.5 4.5 0 0 1-4.5-4.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMicrophone;